let Content = (props) => {
  return <div className="pt-14 content">
    {props.children}
  </div>
}

export default Content;
